import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SocialRssIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialRss",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.29 26.29a3.64 3.64 0 1 1-7.28 0 3.64 3.64 0 0 1 7.28 0m8.5 1.71c-.87 0-1.58-.71-1.58-1.58 0-5.83-4.73-10.56-10.56-10.56-.87 0-1.58-.71-1.58-1.58s.71-1.58 1.58-1.58c7.58 0 13.73 6.14 13.73 13.73 0 .87-.71 1.58-1.58 1.58Zm10.62 0c-.87 0-1.58-.71-1.58-1.58 0-11.7-9.48-21.18-21.18-21.19-.87 0-1.58-.71-1.58-1.58s.71-1.58 1.58-1.58c13.44.01 24.34 10.9 24.36 24.34 0 .88-.71 1.6-1.59 1.6Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2 16.63c3.43 0 6.64 1.34 9.06 3.77s3.76 5.68 3.76 9.12h5.28c0-10.02-8.12-18.17-18.1-18.17zm.01-9.35c12.21 0 22.14 9.99 22.14 22.26h5.28C29.43 14.35 17.13 2 2.01 2zm7.3 18.57c0 2.02-1.64 3.66-3.66 3.66s-3.66-1.64-3.66-3.66 1.64-3.66 3.65-3.66 3.66 1.64 3.66 3.66Z"
      })
    })
  }));
};
SocialRssIcon.displayName = 'SocialRssIcon';